/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * General keys
 */
const generalKeys = {
    keyStateApp: {
        webLogin: 'WEB_LOGIN'
    },
    keyTypePostMessage: {
        errorReceivedPostMessage: 'ERROR_RECEIVED_POST_MESSAGE',
        finishedProcessingLastMessage: 'FINISHED_PROCESSING_LAST_MESSAGE',
        // SIGNUP
        initSignUpPage: 'INIT_SIGNUP_PAGE',
        tokenLogin: 'TOKEN_LOGIN',
        // PREFERENCE PAYMENT
        initPPaymentPage: 'INIT_PREFERENCE_PAYMENT_PAGE',
        receivedTokenPPayment: 'TOKEN_PREFERENCE_PAYMENT',
        receivedUpdateInfoPPayment: 'UPDATE_INFO_PREFERENCE_PAYMENT',
        sliderDragEndPPaymentPage: 'SLIDER_DRAGEND_PAYMENT_PAGE',
        userLoadedOnePocket: 'USER_LOADED_ONEPOCKET',
        // OP
        initOPPage: 'INIT_ONEPOCKET_PAGE',
        initOPSliderBluePage: 'INIT_ONEPOCKET_SLIDER_BLUE_PAGE',
        termConsitionOPPage: 'TERM_AND_CONDITION_ONEPOCKET',
        paymentResponseOPPage: 'PAYMENT_RESPONSE_ONEPOCKET',
        refreshUserPoint: 'REFRESH_USER_POINT',
        receivedTokenOPPage: 'TOKEN_ONEPOCKET',
        receivedIdPurchaseOPPage: 'ID_PURCHASE_ONEPOCKET',
        purchaseIdInvalid: 'PURCHASE_ID_INVALID',
        paymentGoToResumeOPPage: 'GO_TO_RESUME_ONEPOCKET',
        initBitacoraPageFinder: 'INIT_BITACORA_PAGE',
        bitacoraReturnPurchaseId: 'BITACORA_PURCHASE_ID',
        detailPaymentOPPage: 'DETAIL_PAYMENT_ONEPOCKET',
        cancelPaymentOPPage: 'CANCEL_PAYMENT_ONEPOCKET',
        successTokenAuth: 'SUCCESS_TOKEN_AUTH',
        // My Account
        initMyAccount: 'INIT_MY_ACCOUNT_PAGE',
        receivedTokenMyAccountPage: 'TOKEN_MY_ACCOUNT',
        receivedLanguage: 'LANGUAGE_CHANGE',
        // Web view
        webViewReturn: 'WEB_VIEW_RETURN',
        // MILES
        initSignUpMilesPayPage: 'INIT_SING_UP_MILES_PAY_PAGE',
        successPaymentLandingMiles: 'SUCCESS_PAYMENT_LANDING_MILES',
        declinedPaymentLandingMiles: 'DECLINED_PAYMENT_LANDING_MILES',
        cancelPaymentLandingMiles: 'CANCEL_PAYMENT_LANDING_MILES',
        // TERM_AND_CONDITIONS
        showTermsAndConditions: 'SHOW_TERMS_AND_CONDITIONS',
        // Amex Change
        typeCreditCardDefault: 'TYPE_CREDIT_CARD_DEFUALT',
        // USER
        errorTokenSessionUser: 'TOKEN_SESSION_USER_ERROR',
        // LOG_OUT
        userTokenLogOut: 'USER_LOG_OUT',
        // GO_TO_HOME
        goToHome: 'GO_TO_HOME',
        openWhatsApp: 'OPEN_WHATSAPP_APP',
        cardScotiaShowModal: 'CARD_SCOTIA_SHOW_MODAL',
        showErrorInAlleTravel: 'SHOW_ERROR_IN_ALLETRAVEL',
        dataDeepAlleTravel: 'DATA_DEEP_ALLETRAVEL',
        jsonDataFixedRates: 'JSON_DATA_FIXED_RATES',

        openExternalUrl: 'OPEN_EXTERNAL_URL',

        trackingData: 'TRACKING_DATA',

        infoForOnepocketSliderBlue: 'INFO_FOR_ONEPOCKET_SLIDER_BLUE',
        updateInfoForOnepocketSliderBlue: 'UPDATE_INFO_FOR_ONEPOCKET_SLIDER_BLUE',

        showCredirCardOPPayment: 'SHOW_CREDIT_CARD_OP_PAYMENT',
        goBackToOPPayment: 'GO_BACK_TO_OP_PAYMENT',

        cancelPopupUppermiles: 'CANCEL_POPUP_UPPERMILES',

        initBuyMilesBluePage: 'INIT_BUY_MILES_BLUE_PAGE',
        infoForBuyMilesBlue: 'INFO_FOR_BUY_MILES_BLUE',

        buyMilesPaymentSuccess: 'BUY_MILES_PAYMENT_SUCCESS',
    },
    keyTrackingData: {
        category: {
            onePocket: 'OP',
            myAccount: 'MY_ACCOUNT'
        },
        action: {
            payConfirm: 'PAY_CONFIRM',
            modifyPayment: 'MODIFY_PAYMENT',
            opSlider: 'OP_SLIDER',
            myAccount: 'MY_ACCOUNT',
            actionMenu: 'ACTION_MENU',
            opInstallments: 'OP_INSTALLMENTS',
        },
        label: {
            purchaseError: 'PURCHASE_ERROR',
            transactionSuccess: 'TRANSACTION_SUCCESS',
            transactioError: 'TRANSACTION_ERROR',
            initSlider: 'INIT_SLIDER',
            initMyAccount: 'INIT_MY_ACCOUNT',
            myProfile: 'MY_PROFILE',

        }
    },
};

const keysCodeError = {
    creditcard: {
        userTokenIsNotvalid: '625'
    },
    uniqueTransaction: {
        userTokenIsNotvalid: '220'
    },
    getAccount: {
        userTokenIsNotvalid: '220'
    }
};

/**
 * General keys
 */
const keysPurchases = {
    statusPurchase: {
        pedding: 1,
        payment: 2
    }
};

/**
 * Franchise tyoe
 */
const franchiseType = {
    TYPE_AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
    TYPE_VISA: 'VISA',
    TYPE_DISCOVERY: 'DISCOVERY',
    TYPE_MASTERCAR: 'MASTERCAR',
};

const keys = {
    user: 'ALLE_2020_USER',
    product: 'ALLE_2020_PRODUCT',
    travel_flights: 'ALLE_2020_FLIGHTS_DATA',
    travel_drive: 'ALLE_2020_DRIVE_DATA',
    travel_hotels: 'ALLE_2020_HOTELS_DATA',
    travel_go_out: 'ALLE_2020_GO_OUT_DATA',
    purchase: 'ALLE_2020_PURCHASE',
    purchaseType: 'ALLE_2020_PURCHASE_TYPE',
    infoPreferencePayment: 'ALLE_2020_INFO_PREFERENCE_PAYMENT',
    productRequest: 'ALLE_2020_PRODUCT_REQUEST',
    detailTransaction: 'ALLE_2020_DETAIL_TRANSACTION',
    card_data: 'ALLE_2020_DATA',
    point: 'ALLE_2020_PONT',
    actionsMessage: 'ALLE_2020_YES-OF-COURSE',
    notification: 'ALLE_2020_NOTIFICATION',
    //  Universal
    universalProperties: 'ALLE_2020_UNIVERSAL_PROPERTIES',
    isAuthenticateWithBiometric: 'ALLE_2020_IS_AUTHENTICATE_WITH_BIOMETRIC',
    //  Flights (Round Trip or One Way)
    roundTripOrOneWay: 'roundTripOrOneWay',
    travelClass: 'travelClass',
    myImages: 'Alle_2020_MY_IMAGES',
    points_porcentage: 'ALLE_2020_POINTS_PORCENTAGE',
    vop_demo: 'VOP_DEMO',
    isSanbox: 'IS_SANBOX',
    sectionTypeFlights: 'flights',
    sectionTypeHotels: 'hotels',
    //
    brandClass: 'BRAND_CLASS',
    idAplication: 'APP_ID_APPLICATION',
    isUniversalLoad: 'ALLE_2020_IS_UNIVERSAL_LOAD',
    flagVerifyProxyTravel: 'FLAG_VERIFY_PROXY_TRAVEL',
    cardScotiaPointsSelected: 'CARD_SCOTIA_POINTS_SELECTED',

    typeInstallments: 'TYPE_INSTALLMENT_SELECTED',
    installments: 'INSTALLMENT_SELECTED',

    external_auth_key: 'ALLE_2020_EXTERNAL_AUTH_KEY',
    external_auth_code: 'ALLE_2020_EXTERNAL_AUTH_CODE',
    external_sso_session_id: 'ALLE_2020_EXTERNAL_SSO_SESSION_ID',

    mustChargeUniversal: 'MUST_CHARGE_UNIVERSAL',
    withoutToken: 'WITHOUT_TOKEN',

    flightTaxes: 'ALLE_2020_FLIGHT_TAXES',

    fixedRates: 'ALLE_2020_FLIXED_RATES',
    productFixedRates: 'ALLE_2020_PRODUCT_FIXED_RATES',

    confirmSale: 'ALLE_2020_CONFIRM_SALE',

    objectSliderOP: 'ALLE_2020_OBJECT_SLIDER_OP',
    credicardTemporalUniqueMethod: 'ALLE_2020_OBJ_CREDITCARD_TEMP_UNIQUE_METHOD',

    responseGetAccount: 'ALLE_2020_RESPONSE_GET_ACCOUNT',
    responseGetCreditCards: 'ALLE_2020_RESPONSE_GET_CREDITCARDS',
    key_jwt_auth_general: 'JWT_TOKEN_AUTH_GENERAL',
    key_jwt_crypto_general: 'JWT_TOKEN_CRYPTO_GENERAL',
    key_jwt_credit_card_general: 'JWT_TOKEN_CREDIT_CARD_GENERAL',
    key_jwt_unique_general: 'JWT_TOKEN_UNIQUE_GENERAL',
    key_jwt_purchase_general: 'JWT_TOKEN_PURCHASE_GENERAL',
    key_jwt_transaction_proxy: 'JWT_TOKEN_TRANSACTION_PROXY',

    objectMopCryptmi: 'ALLE_2020_OBJECT_MOP_CRYPTMI',
    objConfOnePocketBlue: 'ALLE_2020_OBJECT_CONF_OP_BLUE',
    objPayWithVirtualCard: 'ALLE_2020_OBJECT_PAY_WITH_VIRTUAL_CARD',
};

const keysUniversal = {
    REGISTER_WEB_V2: '_REGISTER_WEB_V2',
    REGISTER_WEB: '_REGISTER_WEB',

    app_channel_id: '_APP_CHANNEL_ID',
    app_channel_id_mr: '_APP_CHANNEL_ID_MR',

    AUTH_API_GET_JWTTOKEN_URL_V2: "_AUTH_API_GET_JWTTOKEN_URL_V2",
    AUTH_API_GET_JWTTOKEN_UN: '_AUTH_API_GET_JWTTOKEN_UN',
    AUTH_API_GET_JWTTOKEN_PW: '_AUTH_API_GET_JWTTOKEN_PW',

    whiteListSsl: '_WHITE_LIST_SSL',
    APP_VALIDATION_REQ: '_APP_VALIDATION_REQ',
    APP_VALIDATION_RES: '_APP_VALIDATION_RES',
    //  CREDIT_CARD_WS
    creditcard_api_basic_auth_token: '_CREDITCARD_API_BASIC_AUTH_TOKEN',
    creditcard_api_url_add_credit_card_alle: '_CREDITCARD_API_URL_ADD_CREDIT_CARD_ALLE',
    creditcard_api_url_get_credit_card_alle: '_CREDITCARD_API_URL_GET_CREDIT_CARD_ALLE',
    creditcard_api_url_update_credit_card_alle: '_CREDITCARD_API_URL_UPDATE_CREDIT_CARD_ALLE',
    //  UNIVERSAL_WS
    universal_api_basic_auth_token: '_UNIVERSAL_API_BASIC_AUTH_TOKEN',
    universal_api_url_get_countries: '_UNIVERSAL_API_URL_GET_COUNTRIES',
    universal_api_url_get_city_by_country_id: '_UNIVERSAL_API_URL_GET_CITY_BY_COUNTRY_ID',
    //  AUTH-API_WS
    auth_api_url_register: '_AUTH_API_URL_REGISTER',
    auth_api_url_reset_pw: '_AUTH_API_URL_RESET_PW',
    auth_api_url_forgot_pw: '_AUTH_API_URL_FORGOT_PW',
    auth_api_url_get_account_2: '_AUTH_API_URL_GET_ACCOUNT_2',
    auth_api_url_login: '_AUTH_API_URL_LOGIN',
    auth_api_url_update_account: '_AUTH_API_URL_UPDATE_ACCOUNT',
    auth_api_url_image_profile: '_AUTH_API_URL_IMAGE_PROFILE',
    //  ALLE-API_WS
    alle_api_url_register: '_ALLE_API_URL_REGISTER',
    alle_api_url_assign_product: '_ALLE_API_URL_ASSIGN_PRODUCT',
    alle_api_url_get_product_user: '_ALLE_API_URL_GET_PRODUCT_USER',
    alle_api_url_get_products: '_ALLE_API_URL_GET_PRODUCTS',
    alle_api_url_oauth2_token: '_ALLE_API_URL_OAUTH2_TOKEN',
    alle_api_url_add_purchase_alle: '_ALLE_API_URL_ADD_PURCHASE_ALLE',
    alle_api_header_oauth2_pw: '_ALLE_API_HEADER_OAUTH2_PW',
    alle_api_header_oauth2_us: '_ALLE_API_HEADER_OAUTH2_US',
    alle_api_body_oauth2_pw: '_ALLE_API_BODY_OAUTH2_PW',
    alle_api_body_oauth2_us: '_ALLE_API_BODY_OAUTH2_US',
    //  LIVEPERSON
    live_person_account: '_LIVE_PERSON_ACCOUNT',
    APP_LIVE_PERSON_CAMPAING_ID: '_APP_LIVE_PERSON_CAMPAING_ID',
    APP_LIVE_PERSON_ENGAGEMENT_ID: '_APP_LIVE_PERSON_ENGAGEMENT_ID',
    LIVE_PERSON_API_SEND_ENGAGEMENT_ATTRIBUT: '_LIVE_PERSON_API_SEND_ENGAGEMENT_ATTRIBUT',
    APP_LIVE_PERSON_APLICATTION_ID: '_APP_LIVE_PERSON_APLICATTION_ID',
    //  VIAJES_WS
    viajes_api_url_get_jwt_token: '_VIAJES_API_URL_GET_JWT_TOKEN',
    viajes_api_url_get_travel_filter_information: '_VIAJES_API_URL_GET_TRAVEL_FILTER_INFORMATION',
    viajes_api_url_get_nationality: '_VIAJES_API_URL_GET_NATIONALITY',
    viajes_listener_url_travel_proxy_request: '_VIAJES_LISTENER_URL_TRAVEL_PROXY_REQUEST',
    // PURCHASE_WS
    purchase_api_basic_auth_token: '_PURCHASE_API_BASIC_AUTH_TOKEN',
    purchase_api_url_get_purchase: '_PURCHASE_API_URL_GET_PURCHASE',
    purchase_api_url_add_purchase: '_PURCHASE_API_URL_ADD_PURCHASE',
    // CYBERSOURCE
    cybersource_tokenize_url: '_CYBERSOURCE_TOKENIZE_URL',
    cybersource_tokenize_access_key: '_CYBERSOURCE_TOKENIZE_ACCESS_KEY',
    cybersource_tokenize_unsigned_field_names: '_CYBERSOURCE_TOKENIZE_UNSIGNED_FIELD_NAMES',
    cybersource_tokenize_signed_field_names: '_CYBERSOURCE_TOKENIZE_SIGNED_FIELD_NAMES',
    cybersource_tokenize_transaction_type: '_CYBERSOURCE_TOKENIZE_TRANSACTION_TYPE',
    cybersource_tokenize_profile_id: '_CYBERSOURCE_TOKENIZE_PROFILE_ID',
    cybersource_tokenize_secret_key: '_CYBERSOURCE_TOKENIZE_SECRET_KEY',
    // CARDHOLDER-API_WS
    cardholder_api_basic_auth_token: '_CARDHOLDER_API_BASIC_AUTH_TOKEN',
    cardholder_api_url_points_cards: '_CARDHOLDER_API_URL_POINTS_CARDS',
    // UNIQUETRANSACTION_WS
    uniquetransaction_api_url_uniquetransaction: '_UNIQUETRANSACTION_API_URL_UNIQUETRANSACTION',
    // BITACORA
    bitacora_travel_flights_url: '_BITACORA_TRAVEL_FLIGHTS_URL',
    bitacora_travel_hotels_url: '_BITACORA_TRAVEL_HOTELS_URL',
    // OTROS
    app_default_product_id: '_APP_DEFAULT_PRODUCT_ID',
    app_default_language: '_APP_DEFAULT_LANGUAGE',
    app_url_terms_and_conditions_es: '_APP_URL_TERMS_AND_CONDITIONS_ES',
    app_url_terms_and_conditions_en: '_APP_URL_TERMS_AND_CONDITIONS_EN',

    app_url_terms_and_conditions_m4m_es: '_APP_URL_TERMS_AND_CONDITIONS_M4M_ES',
    app_url_terms_and_conditions_m4m_en: '_APP_URL_TERMS_AND_CONDITIONS_M4M_EN',

    app_default_currency: '_APP_DEFAULT_CURRENCY',
    IATAI_UNIVERSAL_WS_SALT: '_IATAI_UNIVERSAL_WS_SALT',

    GET_LOCATIONS: '_GET_LOCATIONS',
    MIDDLEWARE_URI: '_MIDDLE_WARE_URL',
    TYPE_FIXED_RATES: '_TYPE_FIXED_RATES',

    // Dynamic Bubble
    key_pago_cuotas: '_KEY_PAGO_CUOTAS',
    get_payment_preference: '_GET_PAYMENT_PREFERENCE',
    update_payment_preference: '_UPDATE_PAYMENT_PREFERENCE',

    regex_password: '_REGEX_PASSWORD',

    UNIVERSAL_API_URL_GET_COUNTRIES_V2: "_UNIVERSAL_API_URL_GET_COUNTRIES_V2",
};

const keysTravel = {
    use_extrernal_travel_search: '_USE_EXTERNAL_TRAVEL_SEARCH',
    type_urls_external_travel: '_TYPE_URLS_EXTERNAL_TRAVEL'
};

const flightsClass = {
    economy: { keyJuniper: 'Economy', keyLanguage: 'novaeTravelEconomy' },
    business: { keyJuniper: 'Business', keyLanguage: 'novaeTravelBusiness' },
    firstClass: { keyJuniper: 'First', keyLanguage: 'novaeTravelFirst' }
};

const roundTripOrOneWay = {
    roundTrip: { keyJuniper: 'roundTrip', keyLanguage: 'novaeTravelRoundTrip' },
    oneWay: { keyJuniper: 'oneway', keyLanguage: 'novaeTravelOneWay' }
};

const merchants = {
    visa_hoteles: {
        id: 2
    },
    visa_vuelos: {
        id: 3
    },
    visa_automoviles: {
        id: 6
    },
};

const codeTypePreferences = {
    flight_origin: 'VUEORI',
    flight_destiny: 'VUEDES',
    flight_class: 'CLASS',
    hotels_minimumHotelStarts: 'HOTELES',
    hotels_destiny: 'HOTELDES',
    car_TypeCar: 'CARRO',
    viajero_frecuente: 'VIAJEFREC',
    codigo_programa: 'CODIGOPROG'
};

const livePersonStore = {
    lpAtributesInfo: 'lpAtributesInfo',
    lpVisitorId: 'lpVisitorId',
    lpSessionId: 'lpSessionId',
    lpCampaingId: 'lpCampaingId',
    lpEngamentId: 'lpEngamentId'
};

enum PurchaseStatus {
    Approved = 2, // Aprobada
    Cancelled = 3, // Cancelada
    Reversed = 5, // Reversada
    Refound = 7 // Rembolso
};


enum TransactionStatus {
    Approved = 1,
    Declined = 2,
    Pending = 3,
    Rejected = 4,
    Reversed = 5,
    Canceled = 6,
    Refunded = 7
    };



const purchaseTypes = {
    PAY_WITH_POINTS: 'PAY_WITH_POINTS',
    SCOTIA_PAY_WITH_POINTS: 'SCOTIA',
};

const typeInstallment = {
    TASACERO: 'TASACERO',
    MINICUOTAS: 'MINICUOTAS',
};

const cardTypes = {
    CREDIT: 'CREDIT',
    SCOTIA: 'SCOTIA',
    CREDOMATIC: 'CREDOMATIC',
};

const travelTypes = {
    flights: 'flights',
    hotel: 'hotels',
    activities: 'activities',
    carRental: 'cars',
    vacationHomes: 'vacationHomes',
    transfers: 'transfers'
};

const keyScotia = {
    BIN_LIST_SCOTIA: '_BIN_LIST_SCOTIA'
};

const keysFixedRates = {
    ECR: 'ECR',
    ECR_AMEX: 'ECR_AMEX',
    DR: 'DR',
    DR_AMEX: 'DR_AMEX'
};

const keysCreditCardTypes = {
    virtual: 'virtual',
    user: 'user',
    ownBank: 'OWNBANK'
};

const keyPaymentTypes = {
    Points: 1,
    CreditCard: 2,
    Mixto: 3
};

const keysApp = {
    user: 'ALLE_2020_USER',
    product: 'ALLE_2020_PRODUCT',
    travel_flights: 'ALLE_2020_FLIGHTS_DATA',
    travel_drive: 'ALLE_2020_DRIVE_DATA',
    travel_hotels: 'ALLE_2020_HOTELS_DATA',
    travel_go_out: 'ALLE_2020_GO_OUT_DATA',
    purchase: 'ALLE_2020_PURCHASE',
    productRequest: 'ALLE_2020_PRODUCT_REQUEST',
    detailTransaction: 'ALLE_2020_DETAIL_TRANSACTION',
    card_data: 'ALLE_2020_DATA',
    point: 'ALLE_2020_PONT',

    actionsMessage: 'ALLE_2020_YES-OF-COURSE',

    notification: 'ALLE_2020_NOTIFICATION',

    //  Universal
    universalProperties: 'ALLE_2020_UNIVERSAL_PROPERTIES',

    //  Flights (Round Trip or One Way)
    roundTripOrOneWay: 'roundTripOrOneWay',
    travelClass: 'travelClass',

    myImages: 'Alle_2020_MY_IMAGES',
    urlImagesProfile: 'ALLE_2020_URL_IMAGE_PROFILE',

    keyBiometric: 'ALLE_2020_KEY_BIOMETRIC',

    purchaseCount: 'ALLE_2020_PURCHASE_COUNT',
    goToRating: 'ALLE_2020_GO_TO_RATING',
    transactionType: 'TRANSACTION_TYPE',
    transactionEdit: 'TRANSACTION_EDIT',
    TYPE_TOKENIZE_CONFIG: '_TYPE_TOKENIZE_CONFIG',
    SECURITY_LAST_OBJ: 'SECURITY_OBJ',
};

const keyJsonFixedRates = {
    json_fixed_rates: 'JSON_FIXED_RATES'
};

const keyTypeDestiny = {
    origin: 'ORIGIN',
    destination: 'DESTINATION'
};

const iframePageWebLogin = [
    'my-account',
    'onepocket',
    'onepocket-points',
    'sign-up',
    'sing-up-miles-pay',
    'onepocket-slider-blue',
    'buy-miles-blue',
];

const merchantAccountId = {
    benefits: 1,
    hotel: 2,
    flight: 3,
    activities: 4,
    travel: 5,
    cars: 6,
    transfers: 7,
    miles: 8,
    donate: 9,
    crypto: 10,
    paymi: 11,
    store: 12
};

export { keysApp, keys, merchantAccountId, cardTypes, iframePageWebLogin, typeInstallment, keysFixedRates, keyScotia, keysUniversal, keysTravel, livePersonStore, generalKeys, keysPurchases, merchants, codeTypePreferences, travelTypes, flightsClass, roundTripOrOneWay, franchiseType, keysCodeError, PurchaseStatus, TransactionStatus, purchaseTypes, keysCreditCardTypes, keyPaymentTypes, keyJsonFixedRates, keyTypeDestiny };
